module.exports = __webpack_public_path__ + "static/media/Feather.4fc8c948.ttf";